import React, { Component } from "react"
import { withRouter } from "react-router-dom"
import Layout from "../Layout"
import { UsuariosForm } from "../modais"
class UsuariosEditForm extends Component {
  constructor() {
    super()
    this.onSuccess = this.onSuccess.bind(this)
  }
  onSuccess() {
    this.props.history.push("/usuarios")
  }
  render() {
    return (
      <Layout tabActive="Operadores">
        <UsuariosForm isEditing={true} callBackUsuarios={this.onSuccess} />
      </Layout>
    )
  }
}
export default withRouter(UsuariosEditForm)



// WEBPACK FOOTER //
// ./src/views/usuarios/UsuariosEditForm.js